import { render, staticRenderFns } from "./TripTelematics.vue?vue&type=template&id=5faef062"
import script from "./TripTelematics.vue?vue&type=script&lang=js"
export * from "./TripTelematics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports